import React, { useContext } from "react";
import axios from "axios";
import { base_url } from "../../config";
import RegistrationContext from "../../contexts/RegistrationContext";

export const Cancellation = () => {
  const { data, setError } = useContext(RegistrationContext);
  const [cancellationPolicy, setCancellationPolicy] = React.useState(false);
  const [reason, setReason] = React.useState("");
  const [additionalComments, setAdditionalComments] = React.useState("");
  const [cancellation_requested, setCancellationRequested] = React.useState(
    data.cancellation_requested
  );
  const toggleCancellationPolicy = () => {
    setCancellationPolicy(!cancellationPolicy);
  };

  const handleCancellation = async () => {
    try {
      await axios.post(
        `${base_url}/api/cancellation_request`,
        {
          cancellation_reason: reason,
          cancellation_comments: additionalComments,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      setCancellationRequested(true);
    } catch (error: any) {
      setError(
        "Unexpected error. " + error.response?.data?.message || error.message
      );
    }
  };

  if (cancellation_requested) {
    return (
      <div className="rounded-lg border bg-white p-6 shadow-sm">
        <h2 className="mb-4 text-xl font-bold">Cancellation Request</h2>
        <p className="text-sm text-gray-500">
          Your cancellation request has already been submitted. We will process
          it and get back to you shortly.
        </p>
      </div>
    );
  }

  return (
    <div
      className=" rounded-lg border bg-white p-6 shadow-sm"
      id="cancellation"
    >
      <h2 className="mb-4 text-xl font-bold">Request Cancellation</h2>

      <div className="rounded-lg border border-amber-200 bg-amber-50 p-4 text-amber-800">
        <p className="mb-2 font-medium">Cancellation Policy:</p>
        <ul className="list-inside list-disc space-y-1 text-sm">
          <li>
            Full refund (minus $150 processing fee) for cancellations before
            July 15, 2026 (23:59 AoE)
          </li>

          <li>No refunds for cancellations after July 15, 2026 (23:59 AoE)</li>
          <li>Registrations are not transferable</li>
        </ul>
      </div>

      <div className="mt-4 rounded-lg border p-4">
        <h4 className="mb-3 font-medium">Cancellation Request Form</h4>
        <div className="space-y-4">
          <div>
            <label className="mb-1 block text-sm font-medium">
              Reason for Cancellation
            </label>
            <select
              className="w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm"
              onChange={(event) => setReason(event.target.value)}
            >
              <option>Please select a reason</option>
              <option>Schedule conflict</option>
              <option>Travel issues</option>
              <option>Health reasons</option>
              <option>Other</option>
            </select>
          </div>

          <div>
            <label className="mb-1 block text-sm font-medium">
              Additional Comments
            </label>
            <textarea
              className="w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm"
              rows={3}
              placeholder="Please provide any additional information regarding your cancellation request"
              onChange={(event) => setAdditionalComments(event.target.value)}
            ></textarea>
          </div>

          <div className="flex items-center gap-2">
            <input
              type="checkbox"
              id="confirm-policy"
              className="h-4 w-4 rounded border-gray-300"
              onClick={() => toggleCancellationPolicy()}
            />
            <label htmlFor="confirm-policy" className="text-sm">
              I understand and agree to the cancellation policy
            </label>
          </div>

          <div className="flex justify-end gap-2">
            <button
              className="flex items-center gap-2 rounded-md bg-red-600 px-4 py-2 text-sm font-medium text-white hover:bg-red-700 disabled:opacity-50"
              disabled={!cancellationPolicy}
              onClick={() => handleCancellation()}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="h-4 w-4"
              >
                <circle cx="12" cy="12" r="10" />
                <line x1="15" x2="9" y1="9" y2="15" />
                <line x1="9" x2="15" y1="9" y2="15" />
              </svg>
              Submit Cancellation Request
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
